import React from 'react';

const SistemCMSDesaRamahAdmin: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Sebuah website desa yang indah dan kaya fitur akan menjadi sia-sia apabila informasi di dalamnya tidak pernah diperbarui karena sistem pengelolaannya terlalu rumit untuk digunakan oleh staf kantor desa. Di banyak daerah, keterbatasan literasi teknis perangkat desa menjadi alasan utama mangkraknya portal informasi publik setelah masa serah terima proyek selesai.
      </p>

      <p className="mb-4">
        Dalam perancangan platform <b>EcoQuest Village Website Application</b>, peserta dituntut untuk merancang <b>Content Management System (CMS)</b> yang mengedepankan kemudahan penggunaan (<i>ease of use</i>), keamanan hak akses, dan alur kerja pembaruan konten yang intuitif.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Tiga Pilar Dashboard CMS Desa yang Efektif
      </h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Editor Teks Visual (WYSIWYG yang Sederhana):</strong> Memungkinkan admin mengunggah berita kegiatan desa, pengumuman bantuan sosial, dan foto galeri tanpa perlu menulis kode HTML sama sekali.
        </li>
        <li>
          <strong>Pengelolaan Modul Terpisah:</strong> Memisahkan manajemen profil desa, data kependudukan, katalog produk UMKM, dan kontak layanan darurat ke dalam tab navigasi yang jelas dan terorganisir.
        </li>
        <li>
          <strong>Otorisasi Berbasis Peran (Role-Based Access Control):</strong> Membedakan hak akses antara kepala desa (<i>Super Admin</i>) dan staf administrasi umum untuk mencegah perubahan data vital secara tidak sengaja.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Validasi Form dan Pencegahan Kesalahan Input
      </h2>
      <p className="mb-4">
        Sistem CMS yang andal harus dilengkapi dengan validasi input yang ketat namun komunikatif, seperti pembatasan ukuran file gambar otomatis, pratinjau langsung sebelum artikel diterbitkan (<i>live preview</i>), dan pesan petunjuk bahasa Indonesia yang mudah dipahami.
      </p>

      <p className="mb-4">
        Dengan menghadirkan dashboard CMS yang ramah pengguna, website desa tidak lagi menjadi proyek seremonial sesaat, melainkan sarana komunikasi dinamis yang aktif melayani kebutuhan informasi warga desa setiap hari.
      </p>
    </div>
  );
};

export default SistemCMSDesaRamahAdmin;
